import { render } from "./GameSlider.vue?vue&type=template&id=bdcea6c4"
import script from "./GameSlider.vue?vue&type=script&lang=js"
export * from "./GameSlider.vue?vue&type=script&lang=js"

import "./GameSlider.vue?vue&type=style&index=0&id=bdcea6c4&lang=css"
script.render = render

export default script